import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Box, constants, Text } from '@match/react-component-library';
import { Truncate } from '../../../components/Truncate';
import { messages } from '../Greeting';

const { TYPOGRAPHY } = constants;

interface DefaultGreetingProps {
  handle?: string;
}

export const DefaultGreeting: React.FunctionComponent<DefaultGreetingProps> = ({ handle }) => {
  const greetingContent = () => {
    if (handle) {
      return (
        <React.Fragment>
          <Text typography={TYPOGRAPHY.HEADING1} bold>
            <Truncate width={320}>
              <FormattedMessage {...messages.salutation} /> {handle},
            </Truncate>
          </Text>
          <Text typography={TYPOGRAPHY.HEADING1} bold>
            <FormattedMessage {...messages.howCanWeHelp} />
          </Text>
        </React.Fragment>
      );
    } else {
      return (
        <Text typography={TYPOGRAPHY.HEADING3} bold>
          <FormattedMessage {...messages.salutation} />
          ,&nbsp;
          <FormattedMessage {...messages.howCanWeHelp} />
        </Text>
      );
    }
  };

  return (
    <Box display="flex" flexDirection="column">
      {greetingContent()}
    </Box>
  );
};
